module.exports = __webpack_public_path__ + "static/media/icon5-active.e669554e.svg";